/**
 * useAgentOverride.ts
 *
 * Watches the agentOverride field in the store (populated by real-time subscription).
 * When an agent sets targetStep, this hook navigates the user to that step.
 * When an agent sets a message, AgentBanner picks it up directly from the store.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '@/store';

const STEP_ROUTES: Record<number, string> = {
  1: '/search',
  2: '/results',
  3: '/seats',
  4: '/passengers',
  5: '/payment',
  6: '/confirmation',
};

export function useAgentOverride() {
  const navigate = useNavigate();
  const agentOverride = useStore((s) => s.agentOverride);

  useEffect(() => {
    if (!agentOverride) return;

    if (agentOverride.targetStep) {
      const route = STEP_ROUTES[agentOverride.targetStep];
      if (route) {
        navigate(route, { replace: true });
      }
    }
  }, [agentOverride?.targetStep]);

  return agentOverride;
}
